import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { READING_MEMBER_OBJECT } from 'src/app/dummy/status';
import { Router, ActivatedRoute } from '@angular/router';
import { PrintService } from 'src/app/services/print.service';
import { TESTING_CENTER } from 'src/app/dummy/tab';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { BookstoreStore } from 'src/app/stores/bookstore/bookstore.store';
import { MatDialog, MatSnackBar } from '@angular/material';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { FireStorageService } from 'src/app/services/fire-storage.service';
import { AddReadingBatchComponent } from './add-reading-batch/add-reading-batch.component';

@Component({
  selector: 'app-reading-batch',
  templateUrl: './reading-batch.component.html',
  styleUrls: ['./reading-batch.component.scss']
})
export class ReadingBatchComponent implements OnInit {
  @ViewChild('PRINT_TABLE', {static:false}) PRINT_TABLE: ElementRef;
  tabs = TESTING_CENTER.READING_BATCH_MEMBERS;

  constructor(
    private router: Router,
    private dialog: MatDialog,
    public store: BookstoreStore,
    public ps: PrintService,
    private storage: FireStorageService,
    private snackBar: MatSnackBar,
  ) { }

  async ngOnInit() {
    this.store.selectedBatch = null;
    this.store.fetchReadingBatches()
  }

  create(item?: any) {
    const dialogRef = this.dialog.open(AddReadingBatchComponent, {
      data: { STUDENT: item || null },
      panelClass: "register-test-overlay-panel",
      width: "35vw",
      height: "100vh",
      disableClose: true,
      role: "dialog"
    });
    dialogRef.updatePosition({ top: "0", right: "0", bottom: "0" });
    dialogRef.afterClosed().subscribe(result => { });
  }

  delete(item: any) {
    let dialogRef = this.dialog.open(DeleteComponent, {
      data: { title: 'Delete Book', memo: 'Document will delete from you and student.', name: item.name },
      width: '35vw',
      disableClose: true,
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        try {
          const { audioFileDetail, bookFileDetail, coverFileName } = item;
          if (bookFileDetail.filename) {
            this.storage.storageRef(bookFileDetail.filename).delete();
          }
          audioFileDetail.forEach(m => {
            this.storage.storageRef(m.filename).delete();
          })
          coverFileName.forEach(m => {
            this.storage.storageRef(m.filename).delete();
          })
        } catch (error) {
        }
        this.store.deleteItem(COLLECTION_NAME.STUDENTS, item, (success, res) => {
          this.snackBar.open("Member has been deleted successful.", "Done", { duration: 1000 });
        })
      }
    });
  }

}
